







import Vue from "vue";

export default Vue.extend({
    name: "KeyboardKey",
    props: {
        inputKey: {
            type: String,
            required: true
        },
        keyValue: {
            type: String,
            required: true
        }
    },
    methods: {
        keyPressed(): void {
            window.dispatchEvent(
                new KeyboardEvent("keydown", {
                    key: this.keyValue ? this.keyValue : this.inputKey,
                })
            );
        }
    }
})



